import { graphql, useStaticQuery } from 'gatsby';

import { useFlatten } from './use-flatten';
import { getProperty } from 'utils';

export const useStaticFacts = () => {
	const results = useStaticQuery(query) || {};
	const key = 'squidex.findFactsSingleton';

	return useFlatten(getProperty(results, key) || {});
};

const query = graphql`
	query useFactsQuery {
		squidex {
			findFactsSingleton {
				id
				data {
					employees {
						iv
					}
					communities {
						iv
					}
					residences {
						iv
					}
					objects {
						iv
					}
					rentFacilities {
						iv
					}
					hirePurchaseFacilities {
						iv
					}
					propertyFacilities {
						iv
					}
				}
			}
		}
	}
`;
